<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
    <form>
      <div >
        <h1>Order from {{venue_name}}</h1>
        <span class="flex justify-center">{{venue_address}}</span>
      </div>

      <vs-input readonly label="Your Food Amount" class="mb-5" v-model="food_amount"></vs-input>
      <vs-input readonly label="Your Taxi Amount" class="mb-5" v-model="taxi_amount"></vs-input>
      <div class="flex w-full">

      <h5 class="mt-5 mr-4"> Total : {{food_amount+taxi_amount}}</h5>
      <vs-button icon-pack="feather" size="large" @click="payNow">Pay Now</vs-button>
      </div>
    </form>
    <div class="flex w-full items-center justify-center">
      <form :action="postUrl" method="post" v-if="postUrl">
        <input id="Reference" name="Reference" type="hidden" :value="reference" />
        <input
          type="submit"
          value="Checkout"
          class="vs-component vs-button vs-button-primary vs-button-filled medium"
        />
      </form>
    </div>
  </div>
</template>
<script>
import * as axios from "@/services/Axios";

import { _getOrder } from "@/services/Payment";

export default {
  data() {
    return {
      postUrl: null,
      refernece: null,
      // res: "",
      food_amount: 0,
      taxi_amount: 0,
      venue_name: "",
      venue_address: "",
      order_number: this.$route.params.number
    };
  },
  beforeMount() {
    _getOrder(this.order_number).then(res => {
      this.food_amount = Number(res.data.food_cost);
      this.taxi_amount = Number(res.data.taxi_cost);
      this.venue_name = res.data.venue_name;
      this.venue_address = res.data.venue_address;
      console.log(res.data);
    });
  },
  destroyed() {
    console.log('closing');
  },

  methods: {
    payNow() {
      const data = {
        food_cost: this.food_amount,
        taxi_cost: this.taxi_amount,
        order_number: this.order_number
        // phoneNumber: this.phoneNumber
      };
      axios
        .post(`pay/${this.order_number}`, data)
        .then(resp => {
          this.postUrl = resp.data.postUrl;
          this.reference = resp.data.reference;
          // this.res = resp.data;
          console.log(resp);
        })
        .catch(error => {
          alert(error.response.data.message);
        });
    }
  }
};
</script>
<style lang="scss">
.booking-content-scroll-area {
  position: absolute;
  margin: auto;
  width: 100%;
  height: calc(100% - 170px);
  &:not(.ps) {
    overflow-y: auto;
  }
}
.header-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    > button {
      margin-left: 10px;
    }
  }
}

.footer-sidebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  > button {
    border: 0px solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
    border-radius: 0px !important;
  }
}
.mt-20 {
  margin-top: 20px;
}
.w-300 {
  width: 300px;
}
.h-150 {
  height: 150px;
}
</style>


